exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".QuickSearchModal_QuickSearch_3OKo6 {\n    padding: 10px 10px 10px 0px;\n}\n\n.QuickSearchModal_Message_3J6Jw {\n    /*font-weight: bolder;*/\n    padding-left: 10px;\n    font-size: 16px;\n}\n\n.QuickSearchModal_FormTitle_3FIjh {\n    color: #337ab7;\n    margin: auto;\n    align-items: left;\n    display: flex;\n    flex-flow: row;\n    justify-content: left;\n    font-size: 18px;\n    font-weight: bolder;\n    margin: 10px 0px 0 10px;\n}", ""]);

// Exports
exports.locals = {
	"QuickSearch": "QuickSearchModal_QuickSearch_3OKo6",
	"Message": "QuickSearchModal_Message_3J6Jw",
	"FormTitle": "QuickSearchModal_FormTitle_3FIjh"
};